import { useMemo } from 'react';

import { ROUTES, PAGE_SETTINGS_ROUTE_MAP, PageSettingsKey } from 'shared/constants';
import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';

import { useGetFormattedSettings } from './useGetFormattedSettings';

export const useGetDisabledRoutes = () => {
  const { data } = useGetFormattedSettings();
  const { isCurrentAccountObserver, paymentRoutesDisabled } = useAccessibleAccounts();

  return useMemo(() => {
    const disabledRoutesArray: string[] = [];

    if (!data) {
      return disabledRoutesArray;
    }

    if (!data.directDebitEnabled) {
      disabledRoutesArray.push(ROUTES.DIRECT_DEBIT);
    }

    (Object.entries(PAGE_SETTINGS_ROUTE_MAP) as [PageSettingsKey, string][]).forEach(
      ([pageKey, route]) => {
        if (data.visual?.pageSettings?.[pageKey]?.isVisible === false) {
          disabledRoutesArray.push(route);
        }
      }
    );

    if (data?.disableOneOffPayments) {
      disabledRoutesArray.push(ROUTES.MAKE_PAYMENT);
    }

    if (!data.reEnrolment.isEnabled) {
      disabledRoutesArray.push(
        ROUTES.RE_ENROLMENT_OPTIONS,
        ROUTES.RE_ENROLMENT_CONFIRMATION,
        ROUTES.RE_ENROLMENT_CONTRACT
      );

      if (!paymentRoutesDisabled) {
        disabledRoutesArray.push(ROUTES.RE_ENROLMENT);
      }
    }

    if (paymentRoutesDisabled) {
      disabledRoutesArray.push(
        ROUTES.HOME,
        ROUTES.INVOICES,
        ROUTES.PAYMENTS,
        ROUTES.MAKE_PAYMENT,
        ROUTES.DIRECT_DEBIT,
        ROUTES.BOLETO_PAYMENT,
        ROUTES.SUCCESS_PAYMENT
      );
    }

    if (isCurrentAccountObserver) {
      disabledRoutesArray.push(
        ROUTES.MAKE_PAYMENT,
        ROUTES.DIRECT_DEBIT,
        ROUTES.BOLETO_PAYMENT,
        ROUTES.SUCCESS_PAYMENT,
        ROUTES.RE_ENROLMENT,
        ROUTES.RE_ENROLMENT_OPTIONS,
        ROUTES.RE_ENROLMENT_CONFIRMATION,
        ROUTES.RE_ENROLMENT_CONTRACT,
        ROUTES.CONTACT_US
      );
    }

    return disabledRoutesArray;
  }, [data, paymentRoutesDisabled, isCurrentAccountObserver]);
};
